export default {
    ru: {
        product: 'Личный кабинет врача',
        enter: 'Войти',
        authtitle: 'Авторизация',
        regtitle: 'Регистрация',
        email: 'e-mail',
        login: 'Логин',
        firstname: 'Имя',
        enterfirstname: 'Введите фамилию пациента',
        searchph: 'Введите телефон пациента',
        lastname: 'Фамилия',
        surname: 'Отчество',
        phone: 'Телефон (Логин)',
        pass: 'Пароль',
        usertype: 'Тип пользователя',
        doctor: 'Доктор',
        patient: 'Пациент',
        passcnf: 'Подтверждение пароля',
        regbtn: 'Зарегистрировать',
        loginph: 'Введите логин',
        passph: 'Введите пароль',
        emptylogin: 'Поле "Логин" не заполнено!',
        emptypass: 'Поле "Пароль" не заполнено!',
        welcome: 'Добро пожаловать в личный кабинет!',
        autherr: 'Авторизация не пройдена! Убедитесь, что Вы ввели правильный Логин и Пароль!',
        regsucc: 'Вы успешно зарегистрированы! На Ваш e-mail отправлено письмо с инструкциями',
        regnotvalid: 'Заполните обязательные поля!',
        settingsbtn: 'Настроить...',
        devicestitle: 'Список приборов',
        refresh: 'Обновить',
        regnewuser: 'Регистрация нового пользователя',
        devicesetting: 'Настройка прибора',
        inputvalue: 'Введите значение',
        selectprogramm: 'Выберите программу',
        selectrange: 'Выберите длительность',
        from: 'от',
        to: 'до',
        closebtn: 'Закрыть',
        loadbtn: 'Чтение',
        recbtn: 'Запись',
        clearbtn: 'Очистка',
        loaddevicebtn: 'Читать из прибора',
        loadtemplatebtn: 'Загрузить из шаблона',
        savetemplatebtn: 'Записать в шаблон',
        savedevicebtn: 'Записать в прибор',
        yesbtn: 'Да',
        nobtn: 'Нет',
        savebtn: 'Сохранить',
        cancelbtn: 'Отмена',
        programm: 'Программа',
        nonselect: 'Не выбрано',
        medic: 'Врач',
        online: 'Включен',
        offline: 'Выключен',
        savesettingssucc: 'Информация успешно записана!',
        setpatientsucc: 'Пациент закреплен за прибором!',
        unsetpatientsucc: 'Пациент откреплен от прибора!',
        savesettingserr: 'Ошибка! Не удалось записать информацию!',
        loadsettingssucc: 'Процедуры успешно загружены!',
        loadsettingserr: 'Ошибка! Не удалось загрузить информацию!',
        cleartitle: 'Очистка настроек',
        clearmessage: 'Удалить все текущие процедуры?',
        unsettitle: 'Открепление пациента',
        unsetmessage: 'Открепить пациента от прибора?',
        savetemplate: 'Запись в шаблон',
        entertemplatename: 'Введите имя шаблона',
        tempelectrode: 'Температура электродов',
        selectpatient: 'Выбор пациента',
        searchresults: 'Результаты поиска',
        currstate: 'Статус прибора',
        isoffline: 'Прибор выключен! Операция невозможна!',
        addpatient: 'Прикрепить пациента',
        log: 'Журнал активности прибора',
        notset: 'Не установлен',
        profiletitle: 'Профиль пользователя',
        changetitle: 'Изменить',
        changepass: 'Измениние пароля',
        changepassbtn: 'Сменить пароль',
        oldpass: 'Введите старый пароль',
        newpass: 'Введите новый пароль',
        changepasssucc: 'Пароль успешно изменен',
        exit: 'Выход',
        exitconfirm: 'Вы действительно хотите выйти из Личного кабинета?',
        exitsucc: 'Вы покинули Личный кабинет! Для входа используйте Авторизацию',
        logtitle: 'Журнал операций прибора',
        course: 'Курс',
        readtime: 'Считано',
        neversynced: 'не синхронизировано',
        rest: 'Осталось процедур',
        missing: 'Отсутствует',
        serialsetsuccess: 'Серийный номер изменен!',
        stateOnDevice: 'Текущие процедуры на приборе',
        refreshBtn: 'Обновить',
        matchTmpl: 'Совпадает с данными на сайте',
        diffCount: 'расхождений с данными на сайте',
        noDataState: 'Нет данных с прибора',
        loadDeviceNote: 'Загружено с прибора. Сравните с шаблоном.',

        columns: {
            uuid: 'Код прибора',
            state: 'Статус прибора',
            devtype: 'Тип прибора',
            is_online: 'Подключен',
            serial: 'Серийный номер',
            pacient: 'Пациент',
            regdate: 'Дата регистрации',
            lastdate: 'Дата последней активности',
            settings: 'Настройка',
            stat: 'Состояние',
            programtype: 'Тип программы',
            amplitude: 'Амплитуда',
            frequency: 'Частота',
            log: 'Журнал',
            hz: 'Гц',
            voltage: 'В',
            min: 'мин',
            time: 'Время',
            procedurecount: 'Количество процедур',
            savedevice: 'Записать в прибор',
            created: 'Создан',
            sent: 'Отправлен',
            note: 'Описание',
            statelog: 'Статус',
            answered: 'Ответ'
        },
        errors: {
            error: 'Ошибка!',
            lastnameempty: 'Поле "Фамилия" не заполнено!',
            firstnameempty: 'Поле "Имя" не заполнено!',
            surnameempty: 'Поле "Отчество" не заполнено!',
            emailempty: 'Поле "E-mail" не заполнено!',
            emailnotvalid: 'Поле "E-mail" не корректно!',
            phoneempty: 'Поле "Телефон" не заполнено!',
            passempty: 'Поле "Пароль" не заполнено!',
            passsimple: 'Поле "Пароль" должно содержать не менее 6 символов!',
            passcnferr: 'Введенные пароли не совпадают!',
            regerr: 'Пользователь с таким логином уже существует!',
            searcherr: 'По Вашему запросу ничего не найдено!',
            setpatienterr: 'Не удалось закрепить прибор за пациентом!',
            unsetpatienterr: 'Не удалось открепить пациента от прибора!',
            emptyvalue: 'Значение не может быть пустым',
            changepass: 'Не удалось изменить пароль!',
            serialchange: 'Не удалось изменить серийный номер!',
            timeempty: 'Укажите время, отличное от 0!',
            countempty: 'Количестов процедур должно быть больше 0!'
        }
    }
}
